import { createRoutine } from 'redux-saga-routines';

export const physicianDetailLookUpRoutine = createRoutine('PHYSICIAN/LOOKUP_DETAIL');
export const physicianInfoRoutine = createRoutine('PHYSICIAN/INFO');
